import type { FAQItem } from "@/pages/landingPage/components";
import { WHATSAPP_URL } from "@/pages/landingPage/utils/whatsapp";

export const SITE_URL = "https://fidexa.com.br";
export const PATH = "/cobranca-whatsapp";
// Sem o sufixo "| Fidexa" aqui: o <Helmet titleTemplate="%s | Fidexa"> global
// (src/App.tsx) já concatena o sufixo no <title> renderizado. og:title e
// twitter:title não passam pelo titleTemplate, então usam OG_TITLE.
export const TITLE = "Cobrança via WhatsApp para Varejo"; // 42 caracteres com o sufixo
export const OG_TITLE = `${TITLE} | Fidexa`;
export const DESCRIPTION =
  "Automatize a cobrança via WhatsApp da sua rede de lojas com a Fidexa: régua de cobrança personalizada, recuperação de crédito e menos inadimplência no varejo."; // 158 caracteres

export const WHATSAPP_HREF = `${WHATSAPP_URL}?text=${encodeURIComponent(
  "Olá! Quero saber mais sobre a cobrança via WhatsApp da Fidexa."
)}`;

export const BREADCRUMB_SCHEMA = {
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: [
    { "@type": "ListItem", position: 1, name: "Início", item: `${SITE_URL}/` },
    {
      "@type": "ListItem",
      position: 2,
      name: "Cobrança via WhatsApp",
      item: `${SITE_URL}${PATH}`,
    },
  ],
};

export const SERVICE_SCHEMA = {
  "@context": "https://schema.org",
  "@type": "Service",
  name: "Cobrança via WhatsApp para o varejo",
  serviceType: "Cobrança automatizada via WhatsApp e gestão de crediário",
  provider: { "@type": "Organization", name: "Fidexa", url: SITE_URL },
  areaServed: { "@type": "Country", name: "Brasil" },
  description: DESCRIPTION,
  inLanguage: "pt-BR",
  url: `${SITE_URL}${PATH}`,
};

// Fatos com fonte em .claude/skills/seo/reference/fidexa-empresa.md.
export const BENEFITS = [
  "Régua de cobrança automática: antes do vencimento, no dia e depois do atraso.",
  "A inteligência artificial ajusta o tom e a frequência das mensagens ao perfil de cada cliente.",
  "Integração com o ERP TOTVS Linx ou importação da base por planilha.",
  "Para quem usa o TOTVS Linx, o cliente paga a parcela por Pix na própria conversa e a baixa é automática (Fidexa Pay).",
  "Todas as lojas da rede em um único painel, com visão separada por unidade.",
  "API oficial do WhatsApp (Meta) e tratamento de dados de acordo com a LGPD.",
];

export const STEPS = [
  {
    title: "Conecte sua base",
    desc: "Integre o TOTVS Linx ou suba clientes e parcelas por planilha, sem trocar o sistema que você já usa.",
  },
  {
    title: "Monte a régua",
    desc: "Defina as mensagens da sua rede para cada etapa: lembrete, vencimento e atraso.",
  },
  {
    title: "A Fidexa cobra por você",
    desc: "As mensagens saem no WhatsApp na hora certa, com o tom ajustado ao perfil de cada cliente.",
  },
  {
    title: "Acompanhe e recupere",
    desc: "Sua equipe acompanha as conversas num chat unificado, separado por loja, e mede o que voltou para o caixa.",
  },
];

// Números públicos da imprensa (ERP 27/08, NV 28/08, BAG 09/09/2026). A taxa
// de recuperação segue a decisão do founder: o dado da plataforma (32,10%).
export const PROOF_METRICS = [
  { value: "R$ 39,34 mi", label: "recuperados para lojistas" },
  { value: "249", label: "empresas usando a Fidexa" },
  { value: "15 mil", label: "mensagens de cobrança por dia, em média" },
  { value: "32,10%", label: "de recuperação média da carteira" },
];

export const FAQ_ITEMS: FAQItem[] = [
  {
    question: "Como funciona a régua de cobrança automática via WhatsApp?",
    answer:
      "A régua dispara mensagens em etapas — antes do vencimento, no dia do vencimento e após o atraso — de forma automática e personalizada para cada cliente, sem precisar de um financeiro disparando manualmente uma a uma.",
  },
  {
    question:
      "A cobrança via WhatsApp da Fidexa usa a API oficial (Meta) ou corre risco de bloqueio?",
    answer:
      "A Fidexa usa a API oficial do WhatsApp (Meta), o que evita o risco de banimento do número que existe em soluções não oficiais e garante que as mensagens de cobrança cheguem de forma estável para o cliente.",
  },
  {
    question:
      "O envio de mensagens de cobrança pelo WhatsApp está de acordo com a LGPD?",
    answer:
      "Sim. A Fidexa segue a LGPD no tratamento dos dados dos clientes cobrados, com acesso controlado por loja e dados protegidos em toda a régua de cobrança via WhatsApp.",
  },
  {
    question: "O cliente consegue pagar a parcela pelo próprio WhatsApp?",
    answer:
      "Sim, para redes que usam o ERP TOTVS Linx. Com o Fidexa Pay, o cliente recebe a cobrança no WhatsApp, escolhe a parcela e paga por Pix ali mesmo, e a Fidexa dá baixa no pagamento automaticamente, sem ninguém precisar conferir o extrato. A integração com outros ERPs está em andamento.",
  },
  {
    question:
      "Como a cobrança via WhatsApp se adapta para redes com várias lojas?",
    answer:
      "A Fidexa foi feita para redes de 4 a 20 lojas: a régua de cobrança é padronizada para toda a rede, mas as conversas e o acompanhamento ficam centralizados em um único painel, com visão separada por unidade.",
  },
];
